export class BottomBar {
    show() {
        const block = document.createElement("div");
        block.classList.add("bottomBarWrapper");
        document.body.prepend(block);
    }
}
